{
  "loading": "載入中...",
  "error": "錯誤",
  "cancel": "取消",
  "confirm": "確認",
  "close": "關閉",
  "open": "開啟",
  "ok": "確定",
  "yes": "是",
  "no": "否",
  "continue": "繼續",
  "back": "返回",
  "next": "下一步",
  "finish": "完成",
  "save": "儲存",
  "delete": "刪除",
  "edit": "編輯",
  "create": "建立",
  "update": "更新",
  "refresh": "重新整理",
  "success": "成功",
  "warning": "警告",
  "info": "資訊",
  "search-placeholder": "搜尋...",
  "message-input": "輸入您的訊息...",
  "please-log-in-to-access-this-page": "請登入以存取此頁面",
  "go-to-settings": "前往設定",
  "go-back": "返回",
  "welcome-user": "歡迎，{$username}！",
  "notification-count": "{$count ->\n   [0] 無通知\n   [1] 一則通知\n   *[other] {$count} 則通知\n  }",
  "user-offline": "使用者離線",
  "user-offline-message": "{$source ->\n   [streamer] 看起來 <1>@{$handle} 離線</1> 了，但他們推薦觀看：\n   *[default] 看起來 <1>@{$handle} 離線</1> 了，但我們推薦觀看：\n  }",
  "user-offline-no-recommendations": "看起來 <1>@{$handle} 離線</1> 了。\n請稍後再來看看。",
  "streaming-title": "正在直播 {$title}",
  "viewer-count": "{$count ->\n   [0] 0 位觀眾\n   [1] 1 位觀眾\n   *[other] {$count} 位觀眾\n  }",
  "pds-selector-title": "初次接觸 Atmosphere？",
  "pds-selector-description": "您需要選擇一個 PDS（個人資料伺服器）來存取 Atmosphere 上的應用程式，例如 Bluesky、Tangled 和 Spark。",
  "pds-selector-custom-label": "其他 PDS",
  "pds-selector-custom-description": "輸入您自己的 PDS 主機網址",
  "pds-selector-custom-url-label": "自訂 PDS 網址",
  "pds-selector-custom-url-placeholder": "https://pds.example.com",
  "pds-selector-learn-more": "了解更多關於自行架設的資訊",
  "pds-selector-info": "每個主機都有自己的政策和可靠性標準。您的 ATProto 資料存放在您選擇的主機上，您可以之後進行遷移。注意：Streamplace 有自己的審核規則——無論您選擇哪個主機，都可能被 Streamplace 封禁。",
  "pds-selector-read-policies": "在繼續之前，請閱讀 {$label} 的<tosLink>服務條款</tosLink>和<privacyLink>隱私政策</privacyLink>。",
  "pds-selector-handle-policy-checkbox": "我已閱讀並同意<policyLink>識別碼政策</policyLink>",
  "login-show-live-on-bluesky": "在 Bluesky 上顯示我的直播狀態",
  "login-show-live-on-bluesky-description": "直播時為您的 Bluesky 頭像加上紅色 LIVE 圓環，並允許 Streamplace 代您發布直播公告。取消勾選即可在不授予任何 Bluesky 帳號存取權限的情況下登入。"
}
